import styled from "styled-components";

import { DATA_E2E_KEY, IStyledAttributes } from "@ryde/shared";
import { blueGreyMui, ScreenDepth } from "@ryde/theme";

export const PhoneLink = styled.a.attrs<IStyledAttributes>({
  "data-e2e": "phone-link",
})`
  text-decoration: none;
  color: ${blueGreyMui._800};
  /*! @noflip */
  direction: ltr;
`;

export const EmailLink = styled.a.attrs<IStyledAttributes>({
  [DATA_E2E_KEY]: "email-link",
})`
  text-decoration: none;
  color: ${blueGreyMui._800};
`;

export const ContactItemEditRootStyled = styled.div.attrs<IStyledAttributes>(
  () => ({
    [DATA_E2E_KEY]: "contact-item-edit-root",
    className: "no-blur-item",
  }),
)`
  position: relative;
  z-index: ${ScreenDepth.INNER_ITEM_EDIT};
  filter: none;
  backdrop-filter: none;
`;
